import React, { useEffect, useState } from "react";
import { Navbar } from "../../../Components/Navbar";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import adjustment from "../../../assets/adjustment.svg";
import arrow from "../../../assets/arrowLeftGreen.svg";
import filter from "../../../assets/filter.svg";
import download from "../../../assets/download.svg";
import trash from "../../../assets/trash.svg";
import AddIcon from "@mui/icons-material/Add";

import { CSVLink } from "react-csv";
// import ExcelFile from "react-export-excel/dist/ExcelPlugin/components/ExcelFile";
// import ExcelSheet from "react-export-excel/dist/ExcelPlugin/elements/ExcelSheet";
// import ExcelColumn from "react-export-excel/dist/ExcelPlugin/elements/ExcelColumn";
import moment from "moment";

import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
// import BookClosureTable from "../../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as ExportIcon } from "../../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/whitePlus.svg";
import { ReactComponent as DeleteIcon } from "../../../myfin_v2/assets/icons/delete_icon_primary.svg";
import Breadcrumb from "../../../myfin_v2/components/Breadcrumb";
import { Delete } from "@material-ui/icons";

const AdjustmentHeader = ({
  adjustmentData,
  filterShow,
  setFilterShow,
  handleOptions,
  onShowDeletedModal,
}) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const history = useHistory();
  const template_action = localStorage.getItem("templateAction");
  const project_id = localStorage.getItem("project_id");

  const workspace_data = useSelector((state) => state.WSReducer);
  const { projectData } = useSelector((state) => state.ADJStandaloneReducer);

  const workspaceName = workspace_data?.response?.[0]?.workspace_name || sessionStorage.getItem("adj_workspace_name") || "Workspace";
  const standaloneName = projectData?.project_name || sessionStorage.getItem("adj_standalone_name") || "Standalone";

  useEffect(() => {
    if (workspace_data?.response?.[0]?.workspace_name) {
      sessionStorage.setItem("adj_workspace_name", workspace_data.response[0].workspace_name);
    }
  }, [workspace_data]);

  useEffect(() => {
    if (projectData?.project_name) {
      sessionStorage.setItem("adj_standalone_name", projectData.project_name);
    }
  }, [projectData]);

  const [exportAdjustments, setExportAdjustments] = useState([]);

  useEffect(() => {
    if (adjustmentData.length > 0) {
      setExportAdjustments([]);

      let serialCounter = 1;
      adjustmentData.forEach((element) => {
        let id = Object.keys(element)[0];
        element[id].forEach((row) => {
          setExportAdjustments((prev) => [
            ...prev,
            {
              SlNo: serialCounter++,
              Date: element.date
                ? moment(element.date).format("DD/MM/YYYY")
                : "",
              ledgerCode: row.ledger_code,
              ledgerName: row.ledger_name,
              branch: row.branch,
              cy: row.cy,
              adjustment: row.adjusted_amount,
              remarks: element.remarks,
            },
          ]);
        });
      });
    } else {
      setExportAdjustments([]);
    }

    return () => {
      // <ExcelFile>
      //     <ExcelSheet name="Ledger Data">
      //         <ExcelColumn label="Ledger Code" value="ledger_code" />
      //         <ExcelColumn label="ledger_name" value="ledger_name" />
      //         <ExcelColumn label="Current Year" value="cy" />
      //         <ExcelColumn
      //             label="Net Adjusted Amount"
      //             value="net_adjusted_amount"
      //         />
      //         <ExcelColumn label="Previous Year" value="py" />
      //         <ExcelColumn label="fS Group" value="fs_grp" />
      //         <ExcelColumn label="Notes Group" value="note_grp" />
      //         <ExcelColumn label="Sub Group" value="sub_grp" />
      //     </ExcelSheet>
      // </ExcelFile>;
      <></>;
    };
  }, [adjustmentData]);

  const csvLink = {
    data: exportAdjustments,
    filename: "Adjustment.csv",
  };

  const breadcrumbItems = [
    {
      label: workspaceName,
      link: `/${template_action}/${project_id}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: standaloneName,
      link: `/${template_action}/${project_id}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Adjustments", link: "", className: "headerLable" },
  ];

  return (
    <>
      <div className="fscp-header" style={{ padding: "15px 0px" }}>
        <Breadcrumb
          style="margin-right:auto"
          addCls={"bgClr1"}
          items={breadcrumbItems}
          headerActions={<></>}
        />
        {/* <SearchIcon width={18} height={18} className="mr-2" /> */}
        <FilterIcon
          width={20}
          height={20}
          className={`mr-3 ${commoncss.clickable}`}
          onClick={() => setFilterShow(!filterShow)}
        />
        <DeleteIcon className={`mr-3 ${commoncss.clickable}`} onClick={() => history.push("/deleted-adjustments")}/>
        <CSVLink {...csvLink}>
          <Button
            icon={<ExportIcon width={18} height={18} />}
            btnColor={buttoncss.secondary}
            class_={buttoncss.greyBg}
            label={"Export"}
          />
        </CSVLink>
          <Button
            icon={<EditIcon width={18} height={18} />}
            btnColor={buttoncss.secondary}
            class_={buttoncss.greyBg}
            label={"Adjustment Logs"}
            onClick={() => {
              history.push("/adjustments-log");
            }}
          />
          <Button
            icon={<PlusIcon width={18} height={18} />}
            btnColor={buttoncss.primary}
            label={"Add new Adjustment"}
            onClick={() =>
              user.responsibilities === "approver" ||
              user.responsibilities === "view"
                ? null
                : handleOptions()
            }
          />
      </div>
    </>
  );
};

export default AdjustmentHeader;
